import * as actionTypes from "./actionTypes";
import { toast } from "react-toastify";

export const enableLoading = () => {
  return {
    type: actionTypes.ENABLE_LOADING,
  };
};

export const disableLoading = () => {
  return {
    type: actionTypes.DISABLE_LOADING,
  };
};

export const handleAPIError = (error, message = "") => {
  return {
    type: actionTypes.HANDLE_API_ERROR,
    error,
    message,
  };
};

// Login Modal
export const showLoginModal = (modalType = "login") => {
  return {
    type: actionTypes.SHOW_LOGIN_MODAL,
    data: modalType,
  };
};

export const hideLoginModal = () => {
  return {
    type: actionTypes.HIDE_LOGIN_MODAL,
  };
};

export const switchLoginForgotPassword = (modalType) => {
  return {
    type: actionTypes.SWITCH_LOGIN_FORGOT_PASSWORD,
    data: modalType,
  };
};

// Menu Detail Modal
export const showMenuDetailModal = (id, displayType) => {
  return {
    type: actionTypes.SHOW_MENU_DETAIL_MODAL,
    id,
    displayType,
  };
};

export const hideMenuDetailModal = () => {
  return {
    type: actionTypes.HIDE_MENU_DETAIL_MODAL,
  };
};

// Select Order Type Modal
export const showSelectOrderTypeModal = (data) => {
  return {
    type: actionTypes.SHOW_SELECT_ORDER_TYPE_MODAL,
    data,
  };
};

export const hideSelectOrderTypeModal = () => {
  return {
    type: actionTypes.HIDE_SELECT_ORDER_TYPE_MODAL,
  };
};

// Top Up Modal
export const showTopUpModal = (data) => {
  return {
    type: actionTypes.SHOW_TOP_UP_MODAL,
    data,
  };
};

export const hideTopUpModal = () => {
  return {
    type: actionTypes.HIDE_TOP_UP_MODAL,
  };
};

export const clearTopUpAmount = () => {
  return {
    type: actionTypes.CLEAR_TOP_UP_AMOUNT,
  };
};
// Order Type
export const getOrderType = () => {
  return {
    type: actionTypes.GET_ORDER_TYPE,
  };
};

export const updateOrderType = (data) => {
  return {
    type: actionTypes.UPDATE_ORDER_TYPE,
    data,
  };
};

export const clearOrderType = () => {
  return {
    type: actionTypes.CLEAR_ORDER_TYPE,
  };
};

// Cart
export const getCart = () => {
  return {
    type: actionTypes.GET_CART,
  };
};

export const updateCart = (data) => {
  return {
    type: actionTypes.UPDATE_CART,
    data,
  };
};

export const clearCart = () => {
  return {
    type: actionTypes.CLEAR_CART,
  };
};

// Store LOLOL ID
export const storeLOLOLID = (data) => {
  return {
    type: actionTypes.STORE_LOLOL_ID,
    data,
  };
};

export const toastSuccess = (message) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.TOAST_SUCCESS });

    toast(message, {
      className: "success",
    });
  };
};

export const toastFail = (message) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.TOAST_SUCCESS });

    toast(message, {
      className: "error",
    });
  };
};

// LOLOL Mall
export const updateMallSearch = (data) => {
  return {
    type: actionTypes.UPDATE_MALL_SEARCH,
    data,
  };
};

export const clearMallSearch = () => {
  return {
    type: actionTypes.CLEAR_MALL_SEARCH,
  };
};

// Modal Alert Set Wallet Pin
export const showModalAlertSetWalletPin = () => {
  return {
    type: actionTypes.SHOW_ALERT_SET_WALLET_PIN,
  };
};

export const hideModalAlertSetWalletPin = () => {
  return {
    type: actionTypes.HIDE_ALERT_SET_WALLET_PIN,
  };
};

// Update IsFirstload
export const updateIsFirstLoad = () => {
  return {
    type: actionTypes.UPDATE_ISFIRSTLOAD,
  };
};

// Hide Shop
export const showHideShopAlert = () => {
  return {
    type: actionTypes.SHOW_HIDE_SHOP_ALERT,
  };
};
export const hideHideShopAlert = () => {
  return {
    type: actionTypes.HIDE_HIDE_SHOP_ALERT,
  };
};
export const doNotShowAlertHideShop = () => {
  return {
    type: actionTypes.DO_NOT_SHOW_ALERT_HIDE_SHOP,
  };
};

// Delivery Operation Hour
export const showDeliveryOperationHourAlert = () => {
  return {
    type: actionTypes.SHOW_DELIVERY_OPERATION_HOUR_ALERT,
  };
};
export const hideDeliveryOperationHourAlert = () => {
  return {
    type: actionTypes.HIDE_DELIVERY_OPERATION_HOUR_ALERT,
  };
};

export const getPhoneNo = () => {
  return {
    type: actionTypes.GET_PHONE_NO,
  };
};

export const getPhoneNoSuccess = (data) => {
  return {
    type: actionTypes.GET_PHONE_NO_SUCCESS,
    data,
  };
};
